import apiClient from "./apiClient";
import { setToken } from "@/lib/utils";

// Định nghĩa types
export interface LoginRequest {
  username: string;
  password: string;
}

export interface RegisterRequest {
  username: string;
  email: string;
  password: string;
  full_name?: string;
  phone?: string;
}

export interface UserResponse {
  success: boolean;
  message: string;
  data?: {
    user: {
      id: number;
      username: string;
      email: string;
      full_name: string;
      phone: string;
      role: string;
      status: string;
      created_at: string;
      updated_at: string;
      avatar_url: string;
      email_verified: boolean;
      phone_verified: boolean;
      last_login: string;
    };
    token: string;
    refreshToken: string;
    expiresIn: string;
  };
}

/**
 * Service xử lý Authentication
 */
export const authService = {
  /**
   * Đăng nhập
   */
  async login(data: LoginRequest): Promise<UserResponse> {
    try {
      const response = await apiClient.post<UserResponse>('/api/auth/login', data);
      
      // Lưu token vào localStorage nếu đăng nhập thành công
      if (response.success && response.data) {
        setToken(response.data.token, response.data.refreshToken);
      }
      
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  /**
   * Đăng ký
   */
  async register(data: RegisterRequest): Promise<UserResponse> {
    try {
      return await apiClient.post<UserResponse>('/api/auth/register', data);
    } catch (error) {
      console.error('Register error:', error);
      throw error;
    }
  },

  /**
   * Đăng xuất
   */
  async logout(): Promise<{success: boolean, message: string}> {
    try {
      return await apiClient.post<{success: boolean, message: string}>('/api/auth/logout', {});
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    }
  },

  /**
   * Lấy thông tin người dùng hiện tại
   */
  async getCurrentUser(): Promise<UserResponse> {
    try {
      return await apiClient.get<UserResponse>('/api/auth/me');
    } catch (error) {
      console.error('Get current user error:', error);
      throw error;
    }
  },

  /**
   * Quên mật khẩu
   */
  async forgotPassword(email: string): Promise<{success: boolean, message: string}> {
    try {
      return await apiClient.post<{success: boolean, message: string}>('/api/auth/forgot-password', { email });
    } catch (error) {
      console.error('Forgot password error:', error);
      throw error;
    }
  },

  /**
   * Đặt lại mật khẩu
   */
  async resetPassword(token: string, password: string): Promise<{success: boolean, message: string}> {
    try {
      return await apiClient.post<{success: boolean, message: string}>('/api/auth/reset-password', {
        token,
        password
      });
    } catch (error) {
      console.error('Reset password error:', error);
      throw error;
    }
  }
};

export default authService; 